import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TdctAuthService } from '../home/tdct-auth/tdct-auth.service';
import { TdctUserService } from '../home/tdct-user/tdct-user.service';
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root',
})

export class AnalyticsGuard  {
  constructor(
    private authService: TdctAuthService,
    private userService: TdctUserService,
    private router: Router,
    private afa: AngularFireAuth
  ) {}

  async canActivate(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.afa.authState.subscribe(async (state) => {
        if (state) {
          const user = await this.userService.get(state.uid);
          const isPremium = !!(user?.isPremium || this.userService.$?.isPremium);
          const roles = user?.roles || this.userService.$?.roles || [];
          const isAdmin = roles.includes('admin');
          if (isPremium || isAdmin) {
            resolve(true);
          } else {
            this.router.navigate(['/home']);
            resolve(false);
          }
        } else {
          this.router.navigate(['/home']);
          resolve(false);
        }
      });
    });
  }
}
